var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      attrs: {
        size: "small",
        "label-position": _vm.$i18n.locale !== "zh" ? "top" : "right",
        "label-width": _vm.$i18n.locale !== "zh" ? "auto" : "120px",
      },
    },
    [
      _c(
        "el-row",
        [
          _vm.type === 1
            ? [
                _c(
                  "el-col",
                  { attrs: { span: 6 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label:
                            _vm.$t("receivablePayable.TicketNumber") + "：",
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.formData.waybillNumber) + " ")]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 6 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label:
                            _vm.$t("receivablePayable.CustomerTrackingNumber") +
                            "：",
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.formData.customerNumber) + " ")]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 6 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("basicData.Outlets") + "：" } },
                      [_vm._v(" " + _vm._s(_vm.formData.siteName) + " ")]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 6 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("receivablePayable.customer") + "：",
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.formData.customerAlias) + " ")]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 6 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("placeOrder.packageType") + "：",
                        },
                      },
                      [
                        _vm.formData.orderPackageType === 1
                          ? _c("span", [
                              _vm._v(_vm._s(_vm.$t("placeOrder.zhifa"))),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.formData.orderPackageType === 2
                          ? _c("span", [
                              _vm._v(_vm._s(_vm.$t("placeOrder.CoPacking"))),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.formData.orderPackageType === 3
                          ? _c("span", [
                              _vm._v(_vm._s(_vm.$t("basicData.other"))),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.formData.orderPackageType === 4
                          ? _c("span", [
                              _vm._v(_vm._s(_vm.$t("placeOrder.big01"))),
                            ])
                          : _vm._e(),
                      ]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 6 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label:
                            _vm.$t("receivablePayable.BillableWeight") + "：",
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.formData.chargeWeight) + " ")]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 6 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("collectionCenter.Recipientzc") + "：",
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.formData.receiveZipcode) + " ")]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 6 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label:
                            _vm.$t("collectionCenter.senderZipCode") + "：",
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.formData.senderZipcode) + " ")]
                    ),
                  ],
                  1
                ),
              ]
            : [
                _c(
                  "el-col",
                  { attrs: { span: 6 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("basicData.OrderNumber") + "：",
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.formData.orderNumber) + " ")]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 6 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("basicData.OrderingCustomer") + "：",
                        },
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.formData.orderCustomerAlias) + " "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 6 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("basicData.UnloadingType") + "：",
                        },
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.formData.loadingTypeAlias) + " "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 6 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("basicData.PaymentMethod") + "：",
                        },
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.formData.paymentMethodAlias) + " "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 6 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("basicData.Mileage") + "：" } },
                      [_vm._v(" " + _vm._s(_vm.formData.totalMileage) + " ")]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 6 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("vehicle.modelLabel") + "：" } },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.formData.vehicleTypeAlias) + " "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 6 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("GlobalSetObj.TheInvoiceAmount") + "：",
                        },
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.formData.totalInvoiceMoney) + " "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 6 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("basicData.Volume") + "：" } },
                      [_vm._v(" " + _vm._s(_vm.formData.totalVolume) + " ")]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 6 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("collectionCenter.SenderCity") + "：",
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.formData.senderCity) + " ")]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 6 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("collectionCenter.receiveCity") + "：",
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.formData.receiverCity) + " ")]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 6 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("basicData.BusinessTime") + "：",
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.formData.businessTime) + " ")]
                    ),
                  ],
                  1
                ),
              ],
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("receivablePayable.remark") + "：" } },
                [_vm._v(" " + _vm._s(_vm.formData.remark) + " ")]
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }